import {
  type JobCatalogEnumsJobCatalogTreeNodeTypesEnum,
  NodePageDocument,
  UpdateJobCatalogTreeNodeDocument,
  UpdateJobCatalogTreeNodeMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useUpdateJobCatalogTreeNode = () => {
  const [mutate, { loading }] = useMutation(UpdateJobCatalogTreeNodeDocument, {
    extractorFn: (data: UpdateJobCatalogTreeNodeMutation) =>
      data.jobCatalogMutations.updateJobcatalogTreeNode,
  })

  const updateNode = (
    companyId: string,
    description: string,
    name: string,
    nodeId: string, //TODO: Remove when the mutation query is updated to use nodeUuid
    nodeType: JobCatalogEnumsJobCatalogTreeNodeTypesEnum, //TODO: Remove when the mutation query is updated to use nodeUuid
    parentId: string, //TODO: Remove when the mutation query is updated to use nodeUuid
    nodeUuid: string
  ) => {
    return mutate({
      variables: {
        companyId,
        description,
        name,
        nodeId,
        nodeType,
        parentId,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            nodeUuid: nodeUuid,
            childType: nodeType, // TODO: Review if this type is correct (it's the same as the type from nodeUuid)
          },
        },
      ],
    })
  }

  return { updateNode, loading }
}

export default useUpdateJobCatalogTreeNode
